import "@quasar/extras/material-icons-outlined/material-icons-outlined.css";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/material-icons-round/material-icons-round.css";
import "@quasar/extras/mdi-v5/mdi-v5.css";
import langDa from "quasar/lang/da";
import {
  Quasar,
  Notify,
  Dialog,
  type QuasarPluginOptions,
  type QuasarUIConfiguration
} from "quasar";
import iconSetround from "quasar/icon-set/material-icons-round";
import type { App } from "vue";

export default {
  install(app: App<Element>) {
    app.use(Quasar, {
      lang: langDa,
      config: {
        brand: {
          primary: "#007e94",
          secondary: "#ff7a00",
          accent: "#00586c",
          positive: "#57d48a",
          negative: "#ff493a",
          info: "#91d1df",
          warning: "#ffd600",
          danger: "#ff493a"
        }
      } as QuasarUIConfiguration,
      plugins: { Notify, Dialog },
      iconSet: iconSetround
    } as Partial<QuasarPluginOptions>);
  }
};
